import React, {useEffect, useState} from "react";
import API from "../../api/axios";
import { useNavigate } from "react-router-dom";

export default function VerifyRegister() {
    const [logo, setLogo] = useState("/logo.png");
    const [agree, setAgree] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const logoParam = params.get("logo");
        if (logoParam) setLogo(logoParam);

        const storedLogo = localStorage.getItem("logo");
        const finalLogo = storedLogo || "/logo.png";
        setLogo(finalLogo);
    }, []);

    const [form, setForm] = useState({
        email: "",
        password: "",
        fk_roles_id: 1,
    });

    const navigate = useNavigate();

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    // Simple local generator. Customize the word lists as you like.
    const generateUsername = () => {
        const adjectives = [
            "swift","sunny","silent","brave","cosmic","clever","lucky",
            "pixel","neon","quantum","noble","fuzzy","crisp","vivid"
        ];
        const animals = [
            "tiger","panda","falcon","otter","lynx","koala","eagle",
            "whale","orca","gecko","panther","wolf","sparrow","yak"
        ];
        const a = adjectives[Math.floor(Math.random()*adjectives.length)];
        const b = animals[Math.floor(Math.random()*animals.length)];
        // short random suffix to reduce collisions
        const suffix = Math.random().toString(36).slice(2, 6); // 4 chars
        const candidate = `${a}${b}-${suffix}`;
        setForm((prev) => ({ ...prev, email: candidate.toLowerCase() }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await API.post("/register", form);
            if (res.data.status) {
                navigate("/VerifyStartVerification/" + res.data.data.id);
            } else {
                alert(res.data.message);
            }
        } catch (err) {
            console.error(err);
            alert(err);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#F7EBFC] px-4 pt-8">
            <img src={logo} alt="" className="max-w-[200px] w-full mb-6" />
            <form
                onSubmit={handleSubmit}
                className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md border border-[#E3BCF4]"
            >
                <h2 className="text-2xl font-semibold text-center mb-6 text-[#9B20AC]">
                    Create an account
                </h2>

                <div className="space-y-4">
                    {/* Username with generate button */}
                    <div className="bg-[#FFF4E5] border-l-4 border-[#FF9800] text-[#d90606] p-3 rounded-md text-sm">
                        <strong>Important:</strong> Copy to notes or take a screenshot of your credentials
                    </div>
                    <div className="flex items-center gap-2">
                        <input
                            name="email"
                            placeholder="Username"
                            type="text"
                            value={form.email}
                            onChange={handleChange}
                            className="w-full pr-12 px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"
                        />
                        <button
                            type="button"
                            onClick={generateUsername}
                            className="p-2 rounded-md border border-[#9B20AC]/30 hover:bg-[#9B20AC]/10 transition"
                            title="Generate username"
                        >
                            <img
                                src="/magic-wand-icon.png" // replace with your uploaded icon path
                                alt="Generate"
                                className="w-5 h-5"
                            />
                        </button>
                    </div>

                    {/*<input*/}
                    {/*    name="email"*/}
                    {/*    placeholder="Email"*/}
                    {/*    type="email"*/}
                    {/*    value={form.email}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"*/}
                    {/*/>*/}
                    <input
                        name="password"
                        type="password"
                        placeholder="Password"
                        onChange={handleChange}
                        className="w-full px-4 py-2 border border-[#9B20AC] rounded-[12px] focus:outline-none focus:ring-1 focus:ring-[#9C27B0]"
                    />
                </div>

                <div className="text-sm sm:text-base text-center mb-6 text-[#652F9B]">
                    <span><br />fast, secure, and completely private. We don’t store or share any of your data.</span>
                </div>

                <button
                    type="submit"
                    className="mt-2 w-full bg-[#8E29CD] hover:bg-[#8E29CD] text-white font-medium py-2 rounded-lg transition duration-200"
                >
                    Sign Up
                </button>

                <p className="mt-4 text-sm text-center text-gray-600">
                    Already have an account?{" "}
                    <span
                        onClick={() => navigate("/login")}
                        className="text-[#740d82] cursor-pointer hover:underline"
                    >
            Login
          </span>
                </p>

                <p className="mt-4 text-sm text-center text-gray-600">
                    By signing up, you agree to our <a href="https://www.18verified.com/terms-and-conditions/" target="_blank">Terms and Conditions.</a>
                </p>

                <div id="revolut-widget" className="mt-6"></div>
            </form>
        </div>
    );
}
